
// different types
export const FIELD_TYPE_TEXT = 'TEXTE'
export const FIELD_TYPE_PASSWORD = 'PASSWORD'
export const FIELD_TYPE_NUMBER = 'NUMBER'
export const FIELD_TYPE_DECIMAL = 'DECIMAL'
export const FIELD_TYPE_DATE = 'DATE'
export const FIELD_TYPE_DATEHEURE = 'DATEHEURE'
